import { atomWithStorage } from 'jotai/utils';

import { storage } from '@service-initiation/shared-utils-jotai';

import { type MailIn } from '../types';

export const mailInAtom = atomWithStorage<MailIn>(
  'si-tec-car-mail-in',
  {
    shippingAddress: undefined,
    shippingLabel: undefined,
  },
  storage<MailIn>(),
  {
    getOnInit: true,
  }
);
